import { render, staticRenderFns } from "./TheDocumentVersions.vue?vue&type=template&id=40f89f2e&scoped=true&"
import script from "./TheDocumentVersions.vue?vue&type=script&lang=js&"
export * from "./TheDocumentVersions.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentVersions.vue?vue&type=style&index=0&id=40f89f2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f89f2e",
  null
  
)

export default component.exports